import { presentationHotKeyModule } from './presentation.module'

export default {
  presentationHotKeyModule,
}
